import { render, staticRenderFns } from "./MenuItemLanguageButtons.vue?vue&type=template&id=ec5ef410&scoped=true"
import script from "./MenuItemLanguageButtons.vue?vue&type=script&lang=js"
export * from "./MenuItemLanguageButtons.vue?vue&type=script&lang=js"
import style0 from "./MenuItemLanguageButtons.vue?vue&type=style&index=0&id=ec5ef410&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5ef410",
  null
  
)

export default component.exports